/**
 * 将style转换为css
 * 将驼峰命名的样式属性转换为连字符命名（kebab-case）
 */


/**
 * Convert camelCase to kebab-case
 * e.g. backgroundColor -> background-color
 */
const camelToKebab = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

export const styleToCss = (style?: React.CSSProperties) => {
    if(!style) {return '';}
    return Object.entries(style).map(([key, value]) => {
        // Convert camelCase property names to kebab-case
        const kebabKey = camelToKebab(key);
        return `${kebabKey}: ${value};`;
    }).join("\n");
}